
var config_promise = $.getJSON("src/js/config/config.json");
var initialConfig = null;

/* D2M */
var instance_options = {
    version: "latest",
    plugins:['best_nodes'],
    container: "viewer",
    callbacks: {
        click: onClickCB,
        enter: onEnterCB,
        leave: onLeaveCB,
        zooming: onZoomCB,
        panning: onZoomingPanning
    }
};

var instance_options_mini = {
    container: "blockmap-mini"
};

var viewer3d_input_options = {
    container: "view3d",
    plugins: ['gallery','navigation'],
    callbacks: {
        click_navigation_node: dvmViewer3dOnClickNavNode
    }
};

var viewer_promise = DVM.loadModule("map_viewer", instance_options);
var viewer_mini_promise = DVM.loadModule("map_viewer", instance_options_mini);
var viewer_3d_promise = DVM.loadModule("3d_viewer", viewer3d_input_options);
var filtering = $.getJSON("src/js/config/filtering/filtering.json");
var navigation = $.getJSON("src/js/config/navigation/navigation.json");
var translation = $.getJSON("src/js/config/translation.json");

// if(interf.params.seatingtype && interf.params.seatingtype==='vip' || interf.params.v360){
//     topview_id = "blockmap";
//     map_id_mini = "blockmap_minimap";
// }

Promise.all([config_promise]).then(function(res){
    initialConfig = res[0];
    initApp();
}).catch(function(err) {
    console.error(err);
});


function initApp(){

    var url = initialConfig.config.url;
    var lang = initialConfig.config.lang;
    var btntxt = initialConfig.interface[lang].ticketsbtn;
    interfaceSetTicketsBtn(url,btntxt);
    
    Promise.all([viewer_promise, viewer_mini_promise, viewer_3d_promise,filtering,navigation,translation])
    .then(function(result) {
        viewer = result[0];
        viewer_mini = result[1];
        viewer_3d= result[2];
        
        filtering = result[3];
        navigation = result[4];
        translation = result[5];
        
        dvmBindInterfaceEvents();
        dvmSetInitialFlags();
        dvmStart(initialConfig.config);
    })
    .catch(function(err) {
        console.error(err);
    });
}
    
    